// src/components/AdminRoute.js
import React, { useContext } from 'react';
import { Typography, Box, Toolbar  } from '@mui/material';
import UserContext from '../context/UserContext';

export default function AdminRoute({ children }) {
    const { user, loading } = useContext(UserContext);

    if (loading) return null;

    if (!user || user.role !== 1) {
        return (
      <>
        {/* This Toolbar component inserts the exact same height as your AppBar */}
        <Toolbar />

        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Typography variant="h6" color="error">
            Access Denied
          </Typography>
          <Typography variant="h6" color="error">
            You don’t have permission to access this resource.
          </Typography>
        </Box>
      </>
    );
    }

    return children;
}